export enum DonorMovement {
  SignificantMovement = 'SignificantMovement',
  SlightMovement = 'SlightMovement',
  UnableToSitStill = 'UnableToSitStill',
  VeryStill = 'VeryStill',
  NotApplicable = 'NotApplicable',
}
